import { render, staticRenderFns } from "./payment-for-goods.vue?vue&type=template&id=6682a920&scoped=true&"
import script from "./payment-for-goods.vue?vue&type=script&lang=js&"
export * from "./payment-for-goods.vue?vue&type=script&lang=js&"
import style0 from "./payment-for-goods.vue?vue&type=style&index=0&id=6682a920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6682a920",
  null
  
)

export default component.exports